export const products = {
  hero: {
    home: 'Home',
    products: 'Products',
    title: 'Filtration & Purification Solutions',
    subtitle: 'Comprehensive range of industrial filtration products sourced from world-leading manufacturers, ensuring quality, performance, and reliability for your operations',
  },
  partners: {
    clickToView: 'Click to view products and solutions',
    industriesServed: 'Industries Served',
    keyBenefits: 'Key Benefits',
    productCategories: 'Product Categories',
    products: 'Products',
    viewProducts: 'View Products',
    featuredProducts: 'Featured Products',
    viewDetails: 'View Details',
    qualitySelectionTitle: 'Quality Selection Process',
    qualitySelectionDesc: 'Every partner is carefully selected based on technological excellence, product quality, global availability, and proven industrial performance. We ensure you receive the best solutions for your specific requirements.',
    requestConsultation: 'Request Product Consultation',
  },
  partnerData: {
    sagisaDescription: 'Leading manufacturer of process engineering and filtration systems and media. Sagisa provides comprehensive solutions including filter housings, reverse osmosis systems and media, and industrial water treatment equipment for diverse applications.',
    sagisaBenefit1: 'Complete filtration systems and media',
    sagisaBenefit2: 'RO technology expertise',
    sagisaBenefit3: 'Water treatment solutions',
    sagisaBenefit4: 'Custom engineering',
    imerysDescription: 'Global leader in mineral-based specialty solutions for industry. Imerys provides diatomaceous earth and perlite filter aids for food, beverage, and industrial filtration applications.',
    imerysBenefit1: 'Mineral-based filtration',
    imerysBenefit2: 'Food grade products',
    imerysBenefit3: 'Proven performance',
    imerysBenefit4: 'Technical support',
    filtroxDescription: 'Specialized manufacturer of filtration media and industrial filtration consumables. CARLSON FILTROX provides high-quality filter sheets, filter cartridges, and filter bags for diverse industrial applications.',
    filtroxBenefit1: 'Quality filter media',
    filtroxBenefit2: 'Wide product range',
    filtroxBenefit3: 'Industrial expertise',
    filtroxBenefit4: 'Reliable performance',
    threeMDescription: 'Global innovation company providing high-performance water filtration systems. 3M delivers advanced filtration solutions for residential, commercial, and food service applications.',
    threeMBenefit1: 'Innovation leader',
    threeMBenefit2: 'Advanced technology',
    threeMBenefit3: 'Global support',
    threeMBenefit4: 'Proven reliability',
    msDescription: 'Specialized manufacturer of microbiological media production for laboratory and industrial applications. M & S delivers high-quality nutrient pad sets for quality control and research.',
    msBenefit1: 'Culture media expertise',
    msBenefit2: 'Quality control solutions',
    msBenefit3: 'Laboratory standards',
    msBenefit4: 'Technical excellence',
    industryWaterTreatment: 'Water Treatment',
    industryIndustrialProcessing: 'Industrial Processing',
    industryCommercial: 'Commercial',
    industryResidential: 'Residential',
    industryFoodBeverage: 'Food & Beverage',
    industryBrewing: 'Brewing',
    industryWineProduction: 'Wine Production',
    industryHealthcare: 'Healthcare',
    industryLaboratoryServices: 'Laboratory Services',
    industryQualityControl: 'Quality Control',
    industryResearchDevelopment: 'Research & Development',
    industryBiotechnology: 'Biotechnology',
    industryFoodService: 'Food Service',
    industryMining: 'Mining',
    industryOilGas: 'Oil & Gas',
    industryPharmaceutical: 'Pharmaceutical',
  },
};